export const createPlayer = ({ id, analyticsData }) => {
  let played = false;
  let completed = false;

  const player = new window.YT.Player(id, {
    events: {
      onReady: (event) => {},
      onStateChange: (event) => {
        const { title: videoName = '', video_id: videoId = '' } = event?.target?.playerInfo?.videoData || {};
        if (!played && event.data === 1) {
          /* eslint-disable-next-line no-console */
          if (window.isDebugMode) console.log('video played', videoName, videoId);
          played = true;
          window.LIFE_CYCLE_EVENT_BUS.trigger('video-player.start', {
            ...(analyticsData || {}),
            videoName,
            videoId,
          });
        } else if (!completed && event.data === 0) {
          /* eslint-disable-next-line no-console */
          if (window.isDebugMode) console.log('video completed', videoName, videoId);
          completed = true;
          window.LIFE_CYCLE_EVENT_BUS.trigger('video-player.complete', {
            ...(analyticsData || {}),
            videoName,
            videoId,
          });
        }
      },
    },
  });
  return player;
};

export function clearPlayerScripts(players) {
  if (players?.length) {
    players.forEach((player) => player.destroy());
    const youtubeScripts = Array(...document.head.children).filter(
      (tag) => tag.tagName === 'SCRIPT' && tag.src && tag.src.includes('youtube')
    );

    while (youtubeScripts.length) {
      const tag = youtubeScripts.pop();
      document.head.removeChild(tag);
    }
  }
}
